import PropTypes from 'prop-types';
import React from 'react';
import TableList from '../../../../components/TableList/TableList';
import Button from '../../../../components/Button';
import colors from '../../../../components/Button/colors';
import dateFormats from '../../../../constants/DateFormats';
import { format, parse } from 'date-fns';
import { formatMoney } from '../../../../utils/reduxForm/formatters';
import config from 'config';

function AutoTopupInfo({ topupInfo, onTopUpClick, onDisableTopupClick }) {
  const { card, topUpDate, amount, activityRange } = topupInfo;
  const fromDateStr =
    activityRange?.[0] &&
    'c ' + format(parse(activityRange?.[0], 'yyyy-MM-dd', new Date()), dateFormats.short) + ' ';
  const toDateStr =
    activityRange?.[1] &&
    'по ' + format(parse(activityRange?.[1], 'yyyy-MM-dd', new Date()), dateFormats.short);
  const topupInfoList = [
    { label: 'Карта для пополнения кошелька', value: card?.label },
    {
      label: 'День пополнения',
      value: topUpDate,
    },
    { label: 'Сумма пополнения', value: formatMoney(amount) },
    {
      label: 'Период действия',
      value: fromDateStr + toDateStr || '',
    },
  ];
  return (
    <div>
      <TableList data={topupInfoList} />
      {!config.isInspectorArm && (
        <div className={'d-flex flex-wrap'}>
          <Button extraClassName={'mt-3 mr-3'} onClick={onTopUpClick}>
            Редактировать автопополнение
          </Button>
          <Button
            extraClassName={'mt-3 nowrap'}
            color={colors.WHITE_BLUE}
            onClick={onDisableTopupClick}
          >
            Отключить автопополнение
          </Button>
        </div>
      )}
    </div>
  );
}

export default AutoTopupInfo;

AutoTopupInfo.propTypes = {
  onDisableTopupClick: PropTypes.func,
  onTopUpClick: PropTypes.func,
  topupInfo: PropTypes.object,
};
